export const CREATE = 'VEHICLE_CHECLIST_CREATE';
export const GET_ITEMS = 'VEHICLE_CHECKLIST_GET_ITEMS'
export const GET = 'VEHICLE_CHECKLIST_GET'
export const LIST = 'VEHICLE_CHECKLIST_LIST'
export const GET_ITEMS_BY_SHIPMENT = 'VEHICLE_CHECKLIST_GET_ITEMS_BY_SHIPMENT'


export const create = (data) => {
  return {
    type: CREATE,
    payload: {
      request: {
        url: '/vehicle_checklist',
        method: 'post',
        data
      }
    }
  }
}

export const getItems = () => {
  return {
    type: GET_ITEMS,
    payload: {
      request: {
        url: `/vehicle_checklist/items`,
        method: 'get',
      }
    }
  }
}

export const get = (search = '') => {
  return {
    type: GET,
    payload: {
      request: {
        url: `/trips/vehicle_checklist`,
        method: 'get',
        params: {
          search
        }
      }
    }
  }
}



export const getVehicleChecklist = (search = '', limit = 10, offset = 0) => {
  return {
    type: LIST,
    payload: {
      request: {
        url: '/vehicle_checklist',
        method: 'get',
        params: {
          search,
          limit,
          offset
        }
      }
    }
  }
}

export const getItemsByShipment = (tripId) => {
  return {
    type: GET_ITEMS_BY_SHIPMENT,
    payload: {
      request: {
        url: `/vehicle_checklist/items/shipment/${tripId}`,
        method: 'get',
      }
    }
  }
}
